import React from 'react';
import PageContainer from '../../../Components/PageContainer/PageContainer';
import { useAuth } from '../../../Providers/AuthProvider/AuthProvider';
import ProducersList from './ProducersList';

const ProducerListPage = () => {
  const { user } = useAuth();

  return (
    <PageContainer withPaddingTop={false} user={user} title="Backoffice - Productoras">
      <ProducersList />
    </PageContainer>
  );
};

export default ProducerListPage;
